import React from 'react'
import UsersContainer from 'containers/panel/admin/users-container'

const UsersPage = () => {
  return (
    <UsersContainer/>
  )
}

export default UsersPage